import script from "./ListPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListPage.vue?vue&type=script&setup=true&lang=ts"

import "./ListPage.vue?vue&type=style&index=0&id=522743de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522743de"]])

export default __exports__